import { Injectable } from '@angular/core';
import {HttpService} from '@api/http/http.service';
import {PaginatedTransfersResponse} from '@api/models/transfer/paginated-transfers-response';
import {TRANSFERS_ROUTE} from '@api/http/http-routes';

@Injectable({
  providedIn: 'root'
})
export class TransfersHttpService {

  constructor(protected http: HttpService) { }


  public async getTransfers(entityType: string, entityId: string, skip: number, limit: number): Promise<PaginatedTransfersResponse> {
    return await this.http.get<PaginatedTransfersResponse>([TRANSFERS_ROUTE, entityType, entityId, skip, limit]);
  }

  public async teamHasTransfers(teamId: string): Promise<boolean> {
    const response = await this.getTransfers('team', teamId, 0, 1)
    return response.data.length > 0
  }
}
